import { createAssetSchemaHooks } from '@innovyze/lib_asset_schema_react';

// Cost tables only read display names, so no asset types are gated by the
// i360-schema-catalog flag: an open flag value keeps every name resolvable.
const OPEN_FLAG = { assets: {} };

export const {
  useAllAssetTypes,
  useAssetTypeSummary,
  useSystemType,
  useSystemTypes,
} = createAssetSchemaHooks(() => OPEN_FLAG);
